import React from "react";
import styles from './stock.module.scss';

function Stock(props) {
  let { data } = props;
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.status} ${data > 0 ? styles.active : styles.inactive}`}>
        <div className={styles.text}>{data > 0 ? 'In Stock ' + data : 'Out of Stock'}</div>
      </div>
    </div>
  );
}
export default Stock;
